<template>
  <div class="drawerWrap">
    <div class="drawerBody">
      <el-form ref="form" :model="form" :rules="formRules" label-width="120px">
        <el-form-item label="巡检类型名称" prop="name">
          <el-input v-model="form.name" minlength="1" maxlength="20" placeholder="请输入巡检类型名称"></el-input>
        </el-form-item>
        <el-form-item label="是否设备类型" prop="isDevice">
          <el-radio-group v-model="form.isDevice">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="drawerFoot">
      <el-button type="primary" @click="confirmHandle()" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
      <el-button @click="cancelHandle()">取 消</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      templateId: {
        type: Number,
        default: null
      },
      templateName: {
        type: String,
        default: ""
      },
      loading: {
        type: Boolean,
        default: false
      },
      handleType: {
        type: String,
        default: ''
      },
      editData: {
        type: Object,
        default: {}
      },
    },
    data() {
      return {
        form: {
          name: "",
          isDevice:"",
          tenantId:'123456',
          parentId:''
        },
        formRules: {
          name: [
            {
              required: true,
              validator: this.validateTemplateName,
              trigger: "blur"
            }
          ],
          isDevice:[
            { required: true, message: '请选择是否为设备类型', trigger: 'change' }
          ]
        },
      };
    },
    created() {
    },
    mounted() {
      this.init();
    },
    methods: {
      init(){
        if(this.handleType=='add'){
          this.form={
            name: "",
            isDevice:"",
            tenantId:'123456',
            parentId:''
          }
        }else if(this.handleType=='addChildren'){
           this.form={
            name: "",
            isDevice:"",
            tenantId:'123456',
            parentId:this.templateId
          }
        }else if(this.handleType='edit'){
           this.form={
            name:this.editData.name,
            isDevice:this.editData.isdevice==1?true:false,
            tenantId:'123456',
            parentId:this.editData.parentId?this.editData.parentId:''
          }
        }
      },
      /**
       * 页面数据校验
       */
      validateTemplateName(rule, value, callback) {
        if (value === "") {
          callback(new Error("巡检类型名称不能为空"));
        } else if (value.length > 20) {
          callback(new Error("巡检类型名称长度不能超过20个字符"));
        } else {
          callback()
        }
      },


      /**
       * 取消
       */
      cancelHandle() {
        this.$emit("cancel", false);
      },
      /**
       * 确认
       */
      confirmHandle() {
        this.$refs["form"].validate(valid => {
          if (!valid) {
            return this.msg.error("请按要求完善表单信息");
          }
          this.$emit("confirm", this.form);
          this.$emit("update:loading", true);
        });
      },
    }
  };
</script>

<style lang="scss" scoped>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  .drawerWrap {
    font-size: 0;
    .openClose {
      width: 48px;
      height: 48px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%
      }
    }

    .contents {
      .checkCons {
        .title {
          width: 105px;
          text-align: right;
          margin-bottom: 20px;
          font-size: 14px;
          color: #6e6e6e;
          font-weight: 400;
        }

        .cons {
          overflow: hidden;

          h3 {
            float: left;
            width: 105px;
            text-align: right;
            font-size: 15px;
          }

          .lists {
            float: left;
            margin-left: 20px;

            ul {
              li {
                line-height: 24px;
                span {
                  display: inline-block;
                  width: 225px;
                  font-size: 14px;
                  color: #6e6e6e;
                }

                i {
                  font-size: 14px;
                  color: #6e6e6e;
                  font-weight: normal;
                  margin-left: 20px;
                  cursor: pointer;
                  padding: 5px 10px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  .drawerWrap {
    .el-transfer {
      .el-transfer-panel {
        text-align: left;
        width: 250px;
      }

      .el-transfer__buttons {
        width: 65px;
        text-align: center;

        .el-button {
          margin: 5px 0;
          width: 56px;
        }
      }
    }

    .el-switch {
      width: 100%;
    }

    .el-image {
      margin-right: 20px;
    }

    .el-form {
      margin-top: 20px;

      .el-form-item__label {
        line-height: 50px;
      }

      .el-form-item__content {
        line-height: 50px;
      }

      .el-select {
        width: 100%;
      }

      .el-textarea {
        width: 270px;

        .el-textarea__inner {
          height: 100px !important;
          line-height: 20px;
          color: #6e6e6e;
          font-size: 14px;
        }
      }

      .el-input {
        width: 270px;

        .el-input__inner {
          height: 40px;
          line-height: 40px;
        }
      }
    }

    .drawerBody .el-form-item__label,
    .sp {
      color: #6e6e6e;
    }

  }
</style>
